import { HARVEST_PHASE_LABELS } from '../../../constants/phases.constants';
import { NUTRIENTS, NUTRIENT_LABELS } from '../../../constants/nutrients.constants';
import type { DynamicParcelEntry } from '../../../types';
import { NutrientInput } from '../../Inputs/NutrientInput/NutrientInput';
import styles from '../NutrientTable/NutrientTable.module.css';

interface DynamicNutrientTableProps {
	data: DynamicParcelEntry[];
	onChange?: (data: DynamicParcelEntry[]) => void;
	isEditing?: boolean;
	errors?: Record<string, string>;
}

export const DynamicNutrientTable = ({ data, onChange, isEditing = false, errors = {} }: DynamicNutrientTableProps) => {
	const update = (index: number, field: keyof DynamicParcelEntry, value: number) =>
		onChange?.(data.map((entry, row) => row === index ? { ...entry, [field]: value } : entry));
	const sum = (field: 'weeks' | typeof NUTRIENTS[number]) =>
		data.reduce((total, entry) => total + (Number.isFinite(entry[field]) ? entry[field] : 0), 0);
	return (
		<div className={styles.container}>
			<div className={styles.tableWrapper}>
				<table className={styles.table} aria-label="Parcelamento dinâmico por fase">
					<thead><tr>
						<th className={styles.headerCell}>Fase</th>
						<th className={styles.headerCell}>Semanas</th>
						{NUTRIENTS.map((nutrient) => <th key={nutrient} className={`${styles.headerCell} ${styles.nutrientHeaderCell}`}>{NUTRIENT_LABELS[nutrient]}</th>)}
					</tr></thead>
					<tbody>{data.map((entry, index) => <tr key={entry.phase}>
						<th scope="row" className={styles.monthCell}>{HARVEST_PHASE_LABELS[entry.phase]}</th>
						<td className={styles.nutrientCell}>{isEditing ? <NutrientInput
							min={1} max={52} step={1}
							aria-label={`Semanas em ${HARVEST_PHASE_LABELS[entry.phase]}`}
							value={entry.weeks}
							onChange={(value) => update(index, 'weeks', value)}
							error={!!errors[`dynamicParcel.${index}.weeks`] || !!errors['dynamicParcel.weeks']}
						/> : <span className={styles.nutrientValue}>{Number.isNaN(entry.weeks) ? '---' : entry.weeks}</span>}</td>
						{NUTRIENTS.map((nutrient) => <td key={nutrient} className={styles.nutrientCell}>
							{isEditing ? <NutrientInput value={entry[nutrient]} onChange={(value) => update(index, nutrient, value)} step={0.1} aria-label={`${nutrient} em ${HARVEST_PHASE_LABELS[entry.phase]}`} error={!!errors[`dynamicParcel.${index}.${nutrient}`] || !!errors[`dynamicParcel.${nutrient}`]} />
								: <span className={styles.nutrientValue}>{Number.isNaN(entry[nutrient]) ? '---' : entry[nutrient]}</span>}
						</td>)}
					</tr>)}</tbody>
					<tfoot><tr className={styles.sumRow}>
						<td className={styles.sumCell}>Total</td>
						<td className={styles.sumValueCell}>{sum('weeks')} / 52</td>
						{NUTRIENTS.map((nutrient) => <td key={nutrient} className={styles.sumValueCell}>{sum(nutrient).toFixed(1)}</td>)}
					</tr></tfoot>
				</table>
			</div>
			{Object.entries(errors).filter(([key]) => key.startsWith('dynamicParcel')).map(([key, message]) => <p key={key} role="alert">{message}</p>)}
		</div>
	);
};
